import simpleCgi from './lib/simpleCgi'

export default class extends simpleCgi {
  constructor(opt) {
    super(opt)
  }

  aesKeys() {
    return []
  }

  cgiName() {
    return 'mobile_subscribe'
  }
}
